import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { mockProjects, mockTasks } from '../../data/mockData.js';
import KanbanBoard from './KanbanBoard.jsx';

// Mock tasks for Kanban view
const mockKanbanTasks = [
    {
        id: 1,
        title: 'Database Schema design',
        description: 'design the database schema for user management module',
        status: 'done',
        priority: 'high',
        assignee: 'Mike Johnson',
        dueDate: '2024-02-15',
        tags: ['Backend', 'Database']
    },
    {
        id: 2,
        title: 'API Endpoint development',
        description: 'Create RESTful API endpoints for CRUD operations',
        status: 'in-progress',
        priority: 'high',
        assignee: 'Abhi Consultant',
        dueDate: '2024-02-20',
        tags: ['Backend', 'API']
    },
    {
        id: 3,
        title: 'User Authentication Flow',
        description: 'Implement JWT-based authentication with refresh tokens',
        status: 'in-progress',
        priority: 'high',
        assignee: 'Emily Consultant',
        dueDate: '2024-02-18',
        tags: ['Security', 'Auth']
    },
    {
        id: 4,
        title: 'Dashboard UI Components',
        description: 'Build reusable dashboard widgets and charts',
        status: 'review',
        priority: 'medium',
        assignee: 'Sarah Investor',
        dueDate: '2024-02-22',
        tags: ['Frontend', 'UI']
    },
    {
        id: 5,
        title: 'Payment Integration',
        description: 'Integrate Stripe payment gateway for subscriptions',
        status: 'todo',
        priority: 'high',
        assignee: 'Mike Johnson',
        dueDate: '2024-02-28',
        tags: ['Backend', 'Payments']
    },
    {
        id: 6,
        title: 'Email Notification System',
        description: 'Set up automated email notifications using SendGrid',
        status: 'todo',
        priority: 'medium',
        assignee: 'Abhi Consultant',
        dueDate: '2024-03-01',
        tags: ['Backend', 'Notifications']
    },
    {
        id: 7,
        title: 'Unit Testing Setup',
        description: 'Configure Jest and write unit tests for core modules',
        status: 'todo',
        priority: 'low',
        assignee: 'Emily Consultant',
        dueDate: '2024-03-05',
        tags: ['Testing', 'devOps']
    },
    {
        id: 8,
        title: 'Mobile Responsive design',
        description: 'Ensure all pages are fully responsive on mobile devices',
        status: 'review',
        priority: 'medium',
        assignee: 'Sarah Investor',
        dueDate: '2024-02-25',
        tags: ['Frontend', 'Mobile']
    },
    {
        id: 9,
        title: 'Documentation',
        description: 'Write API documentation and user guides',
        status: 'todo',
        priority: 'low',
        assignee: 'Mike Johnson',
        dueDate: '2024-03-10',
        tags: ['Docs']
    }
];

export default function KanbanPage() {
    const { id } = useParams();
    const [tasks, setTasks] = useState(mockKanbanTasks);

    // Get project info if projectId is provided
    const project = id ? mockProjects.find(p => p.id === parseInt(id)) : null;

    // Handle task movement between columns
    const handleTaskMove = (taskId, newColumnId) => {
        setTasks(prevTasks =>
            prevTasks.map(task =>
                task.id === taskId
                    ? { ...task, status: newColumnId }
                    : task
            )
        );
    };

    return (
        <div className="p-6">
            <KanbanBoard
                tasks={tasks}
                onTaskMove={handleTaskMove}
                projectId={id}
                projectName={project?.name}
            />
        </div>
    );
}
